import { useContext } from 'react';

import { FormContext } from '../contexts';
import type { RepeatingGroupFormField } from '../typings';
import {
  canRemoveGroupInstance,
  emptiedGroupDisappears,
  getGroupInstanceCount,
  getMinRequiredHint,
} from '../utils';

/** Whether a repeating group instance may be removed, plus its minimum-count hint. */
export const useGroupDeleteGuard = (field: RepeatingGroupFormField) => {
  const { maxItems } = useContext(FormContext);

  const totalCount = getGroupInstanceCount(maxItems, field.fieldId);

  // At the last instance, an absent minimum means no minimum — deferring to
  // canRemoveGroupInstance's `?? 1` default here would hide a delete that
  // genuinely empties the group.
  const canDelete =
    totalCount > 1
      ? canRemoveGroupInstance(totalCount, field.minItems)
      : (field.minItems ?? 0) < 1 && emptiedGroupDisappears(field);

  return {
    allowRemove: field.allowRemove && canDelete,
    minRequiredHint: getMinRequiredHint(field.minItems),
  };
};
